import { HeadTitleContent } from '../../../../commons/Constants';
import ReturnsPage from '../../../../components/body/policies/returns/Returns';

export default function Returns() {
  return <ReturnsPage />;
}
export async function getStaticProps(context) {
  return {
    props: {
      extraMeta: {
        title: HeadTitleContent['returnsPolicy'].title,
        description: HeadTitleContent['returnsPolicy'].description,
      },
    },
  };
}
